import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
var CasePracticeCooperationVideoComponent = (function () {
    function CasePracticeCooperationVideoComponent(apiService, commonService) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.onGoToNextStep = new EventEmitter();
        this.showVideo = true;
    }
    CasePracticeCooperationVideoComponent.prototype.ngOnInit = function () {
        var _this = this;
        window['s2j_onPlayOver'] = function () {
            _this.showVideo = false;
            setTimeout(function () {
                _this.onGoToNextStep.emit(2);
                _this.apiService.ajax({
                    'type': 'post',
                    'url': '/api/pnoStorePoint/' + _this.exerciseId,
                    'data': {
                        'pno_store_point_id': 5
                    }
                }).subscribe(function (result) { });
            }, 300);
        };
    };
    CasePracticeCooperationVideoComponent.prototype.ngAfterViewInit = function () {
        var player = polyvPlayer({
            wrap: '#video-cooperation',
            width: '100%',
            height: this.isPC ? '100vh' : window.screen.width / 9 * 16,
            vid: '352e2664d82e30487b51c6202752d97b_3',
            // autoplay: true,
            // skinLocation: 0,
            ban_history_time: 'on',
            // hideSwitchPlayer: true,
            hideRepeat: true,
            // forceH5: true,
            flashvars: { 'autoplay': true }
            // audioMode: false
        });
        if (!this.isPC) {
            player.toggleFullscreen();
        }
    };
    return CasePracticeCooperationVideoComponent;
}());
export { CasePracticeCooperationVideoComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-video/case-practice-cooperation-video.component.ts.pre-build-optimizer.js